import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BespokePackage } from '../../../models/asset/bespoke-package';
import { FacilitySummary } from '../../../models/asset/facility-summary';
import { Item } from '../../../models/item/item';

@Component({
  selector: 'opt-questionnaire-modal',
  templateUrl: './questionnaire-modal.component.html'
})
export class QuestionnaireModalComponent implements OnInit {
  
  // Properties to pass to the child questionnaire component
  package: BespokePackage;
  facilitySummary: FacilitySummary;
  item: Item;
  booking: any;
  isFullBookingView: boolean = false;
  isReadOnly: boolean;
  data: any;

  showButton: boolean = true;  

  // EventEmitter to expose the onSubmit event for parent components that need to subscribe
  onSubmit = new EventEmitter<any>();

  constructor(
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<QuestionnaireModalComponent>,
    @Inject(MAT_DIALOG_DATA) private injectedData: any
  ) {
    // Pass through all the data from the dialog data to the questionnaire component  
    this.data = this.injectedData;
    this.package = this.injectedData?.packageFilter?.PackageDetail;
    this.facilitySummary = this.injectedData?.fc;
    this.item = this.injectedData?.item;
    this.booking = this.injectedData?.booking;
    this.isFullBookingView = this.injectedData?.isFullBookingView || false;
    this.isReadOnly = this.injectedData?.isReadOnly || false;
    this.dialogRef.disableClose = true;

  }

  ngOnInit() {
  }

  // Handle submission from the child questionnaire component
  onQuestionnaireSubmit(event: any) {
    // Emit the event for parent components that subscribe to onSubmit
    this.onSubmit.emit(event);
    // Close the modal and pass the result back
    this.dialogRef.close(event);
  }
}